import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './ticketcobitkat.list-view.html',
    styleUrls: ['./ticketcobitkat.list-view.scss']
})
export class TicketcobitkatListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
